import { render, staticRenderFns } from "./File.vue?vue&type=template&id=2ff4cda9&scoped=true&"
import script from "./File.vue?vue&type=script&lang=js&"
export * from "./File.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4cda9",
  null
  
)

export default component.exports